module.exports = __webpack_public_path__ + "9cf1695e17a57cda09791caa5bed448f.svg";